import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Record from "../pages/Record";
import Summary from "../pages/Summary";
import NotFound from "../pages/NotFound";
import RedirectPage from "@/pages/Redirect";
import MeetingEnd from "@/pages/MeetingEnd";
import Layout from "@/layout";
import Index from "@/pages";
import SimpleLayout from "@/layout/SimpleLayout";
import ErrorBoundary from "@/pages/ErrorBoundary";
import SummaryPermissionError from "@/pages/SummaryPermissionError";
import AppSummary from "@/pages/App/pages/AppSummary";
import AppLayout from "@/pages/App/layout/AppLayout";
import Share from "@/pages/Share";
import MobileLogin from "@/pages/MobileLogin";
import HotWord from "@/pages/HotWord";
import Voice from "../pages/Voice";
import Collaboration from "@/pages/Collaboration";
import MobileFeedback from "@/pages/MobileFeedback";
import PayPage from '@/pages/Payment/pages/payPage/index'; // 路径根据你的别名或相对路径调整
import PayResult from "@/pages/Payment/pages/payResult";
import DeviceBind from "@/pages/DeviceBind";
import { APP_BASENAME } from "@/config";
import SimulInter from "@/pages/SimulInter";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    children: [
      { index: true, element: <Index /> },
      { path: "deviceBind", element: <DeviceBind /> },
      { path: "home", element: <Home /> },
      { path: "login", element: <Login /> },
      { path: "mobileLogin", element: <MobileLogin /> },
      { path: "record", element: <Record /> },
      { path: "summary", element: <Summary /> },
      { path: "summaryPermissionError", element: <SummaryPermissionError /> },
      { path: "hotWord", element: <HotWord /> },
      { path: "voice", element: <Voice /> },
      { path: "redirect", element: <RedirectPage /> },
      { path: "collaboration", element: <Collaboration /> },
      { path: "mobileFeedback", element: <MobileFeedback /> },
      { path: "MeetingEnd", element: <MeetingEnd /> },
      { path: "simulInter", element: <SimulInter /> }
    ],
  },
  {
    path: "/share",
    element: <SimpleLayout />,
    errorElement: <ErrorBoundary />,
    children: [{ path: "*", element: <Share /> }],
  },
  {
    path: "/payment",
    element: <SimpleLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      { path: "pay", element: <PayPage /> }, 
      { path: "payResult", element: <PayResult /> }
    ],
  },
  {
    path: "/app",
    element: <AppLayout />,
    errorElement: <ErrorBoundary />,
    children: [{ path: "summary", element: <AppSummary /> }],
  },
  { path: "*", element: <NotFound /> }
], {
  basename: `${APP_BASENAME}/`
});

export default function Routes() {
  return <RouterProvider router={router} />;
}
